import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-sign-success-modal',
  templateUrl: './sign-success.component.html',
  styleUrls: ['./sign-success.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
})

export class SignSuccessComponent{



  }
           

